// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.invite-participants-container[data-v-fda498aa] {\n  overflow: hidden;\n  max-width: 435px;\n}\n", ""]);
// Exports
module.exports = exports;
